import { render } from "./SelfAssessmentV2FreeFormInput.vue?vue&type=template&id=6cc387ce&scoped=true"
import script from "./SelfAssessmentV2FreeFormInput.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2FreeFormInput.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2FreeFormInput.vue?vue&type=style&index=0&id=6cc387ce&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc387ce"]])

export default __exports__